import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

export const selectFilteredGeo = createSelector(
  [
    (state: RootState) => state.settings.geoList,
    (state: RootState) => state.geoFilter.selectedGeo,
  ],
  (allGeo, selectedGeo): string[] => {
    if (!selectedGeo.length) {
      return allGeo;
    }

    return allGeo.filter((geo) => selectedGeo.includes(geo));
  },
);
